import { Component, EventEmitter, Input, Output, OnInit } from "@angular/core";
import { MenuItem } from "primeng/api";
import { IEpisode } from "@project/models/episodes/episode";
import { EpisodeService } from "./episode.service";

@Component({
    selector: "episode-header",
    template: `
        <div class="episode-header">
            <div class=flex-wrap>
                <p *ngFor="let diag of episode?.diagnoses let k = index">
                    <span ><b>{{diag.diagnosisCode + ": " + diag.diagnosisName}}</b></span>  &#9679;
                    <span>{{diag.diagnosisBodyPartName}}</span>
                    <span *ngIf="diag.bodySide!=='N/A'"> &#9679; {{diag.bodySide}}</span>
                    <span *ngIf="diag.diagnosisMedicalSystemName"> &#9679; {{diag.diagnosisMedicalSystemName}}</span>
                </p>
            </div>
            <div *ngIf="episode.ravenIssueId" class="flex-wrap">
                <p class="flex-row" >
                    <span><b>{{episode?.ravenIssue.ravenStatus.name}}</b></span> 
                </p>
            </div>
            <div class="flex-row">
                 <div [hidden]="!showDate" class="header-date ">
                     <p><span>Created: {{episodeService.formatDate(episode?.createDateTime)}}</span> <span> {{getTitle(episode?.userTitle)}}  {{episode?.userFullName}}  ({{getRole(episode?.userRole)}})</span></p>
                     <p><span><i>Last Updated: {{episodeService.formatDate(episode?.updateDateTime)}} <span *ngIf="episode?.modifiedUserId">
                     {{getTitle(episode?.userTitle)}}  {{episode?.modifiedUserFullName}}  ({{getRole(episode?.modifiedUserRole)}})</span> </i> </span> </p>
                     <p><span *ngIf="episode?.ravenIssueId">Reference Number: {{episode?.ravenIssue?.referenceNumber}} </span></p>
                 </div>

                <div [hidden]="!showPlusButton">
                    <button class="p-button-text text-white" type="button" pButton pRipple icon="pi pi-plus" (click)="selected();stopClickPropagation($event);menuEpisodePlus.toggle($event)"></button>
                    <p-menu #menuEpisodePlus [popup]="true" [model]="episodeOptionsButtonPlusItems"></p-menu>
                </div>
                <div [hidden]="!showEllipsisButton">
                    <button class="p-button-text text-white" type="button" pButton pRipple icon="mi mi-button-more" (click)="selected();stopClickPropagation($event);menuEpisodeEllipsis.toggle($event)"></button>
                    <p-menu #menuEpisodeEllipsis [popup]="true" [model]="episodeOptionsButtonEllipsisItems"></p-menu>
                </div>
            </div>
        </div>
    `,
    styleUrls: ["./episode-head.component.scss"]
})
export class EpisodeHeadComponent implements OnInit {
    @Input() episodeOptionsButtonPlusItems: MenuItem[] = null;
    @Input() episodeOptionsButtonEllipsisItems: MenuItem[] = null;

    @Input() showPlusButton: boolean = true;
    @Input() showEllipsisButton: boolean = true;
    @Input() showDate: boolean = true;

    @Input() episode: IEpisode = null;

    @Output() readonly onSelected = new EventEmitter<string>();


    constructor(public episodeService: EpisodeService) {
    }

    ngOnInit(): void {
        this.showPlusButton = this.showPlusButton && this.episodeOptionsButtonPlusItems?.filter(o => o.visible).length > 0;
        this.showEllipsisButton = this.showEllipsisButton && this.episodeOptionsButtonEllipsisItems?.filter(o => o.visible).length > 0;
    }

    getTitle (index:number){
        return this.episodeService.getTitle(index);
    }

    getRole(role:string) {
        return this.episodeService.getRole(role);
    }

    get currentEpisodeId(): string {
        return this.episode.id;
    }

    stopClickPropagation(event: any) {
        event.stopPropagation();
    }

    selected() {
        this.onSelected.emit(this.currentEpisodeId);
    }
}
